import { render, staticRenderFns } from "./stardisplay.vue?vue&type=template&id=7f4ab337&"
import script from "./stardisplay.vue?vue&type=script&lang=js&"
export * from "./stardisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f4ab337')) {
      api.createRecord('7f4ab337', component.options)
    } else {
      api.reload('7f4ab337', component.options)
    }
    module.hot.accept("./stardisplay.vue?vue&type=template&id=7f4ab337&", function () {
      api.rerender('7f4ab337', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2GbeC5qQzx6Xf/JS/comp/stardisplay.vue"
export default component.exports